import React, { Component } from 'react';
import { Form, InputNumber } from 'antd';
import { injectIntl, defineMessages  } from 'react-intl';
import ReportDescription from './ReportDescription'
import {getParameterByName} from '../utils/utils'
import {REPORT_URL} from '../utils/constants'

const messages = defineMessages({
    supply_limit: {
      id: 'MaxSupplyLevel',
    },  
});

const layout = {
    labelCol: {
        offset: 0,
        span: 11,
    },
    wrapperCol: {       
        offset: 0,
        span: 11,
    },
  };

const report_type_name = "Report.Consumables";
const supply_limit_name = "supply_limit";
const report_url = "/printers_supplies";

class ConsumablesStep2 extends Component {

    constructor(props) {
        super(props);

        this.supply_limit = this.getSupplyLimit();
        this.saveSupplyLimit(this.supply_limit);

        this.props.callbacks.setStoreValue(report_type_name, REPORT_URL, report_url);
    }

    saveSupplyLimit(supply_limit)
    {
        this.props.callbacks.setStoreValue(report_type_name, supply_limit_name, supply_limit);
    }

    getSupplyLimit()
    {
        var supply_limit = 30;

        var store_value = this.props.callbacks.getStoreValue(report_type_name, supply_limit_name);
        if (store_value !== undefined)
        {
            supply_limit = store_value;
        }
        else
        {
            var url_value = getParameterByName(supply_limit_name, this.props.report.url);
            if (url_value !== null && url_value !== '')
            {
                supply_limit = url_value;
            }
        }

        return supply_limit;
    }

    onFieldsChange(changedFields, allFields)
    {
        if (typeof changedFields !== 'undefined' && changedFields.length > 0)
        {
            this.saveSupplyLimit(changedFields[0].value);
        }
    }

    render() {
    
        return (
            <div style={{align:"center", textAlign: "left"}}>
                <br/>
                <Form {... layout}
                    name="basic"
                    initialValues={{
                        'supply_limit': this.supply_limit,
                    }}
                    onFieldsChange={(changedFields, allFields) => this.onFieldsChange(changedFields, allFields)}
                >
                <Form.Item 
                      label={this.props.intl.formatMessage(messages.supply_limit)} 
                        name="supply_limit" 
                        labelAlign="right"
                >
                    <InputNumber min={0} max={100} 
                        formatter={value => `${value}%`}
                        parser={value => value.replace('%', '')}
                        style={{ width: 120 }}
                    />
                </Form.Item>
                </Form>
                <ReportDescription description="Report.Consumables.Description"/>
            </div>
        );
      }
}

export default injectIntl(ConsumablesStep2, {
    withRef: true,
  });